import Vue from 'vue'
import { commaFormat, commaRemove } from '../filter/number'

const nObj = {
  common: {
    setToValue(obj, value, path) {
      let i
      path = path.split('.')
      for (i = 0; i < path.length - 1; i++) {
        obj = obj[path[i]]
      }
      obj[path[i]] = value
    },
    getToValue(obj, arr) {
      let res = obj
      arr.forEach((v, i) => {
        if (Object.prototype.hasOwnProperty.call(obj, v)) {
          res = nObj.common.getToValue(obj[v], arr.slice(i + 1))
        }
      })
      return res
    },
    getMinValue(el) {
      let min = parseInt(el.getAttribute('min'), 10)
      if (isNaN(min)) {
        min = null
      }
      return min
    },
    getMaxValue(el) {
      let max = parseInt(el.getAttribute('max'), 10)
      if (isNaN(max) || max < 1) {
        max = Number.MAX_SAFE_INTEGER
      }
      return max
    },
  },
  bind(el, bind, vnode) {
    el.addEventListener('input', (e) => {
      e.target.value = commaRemove(e.target.value)
      nObj.inputHandler(el, bind, vnode, e.target.value)
    })
  },
  update(el, bind, vnode) {
    const minValue = nObj.common.getMinValue(el)
    const maxValue = nObj.common.getMaxValue(el)
    const v = nObj.common.getToValue(vnode.context, bind.expression.split('.'))

    if (!!minValue && v < minValue) {
      nObj.common.setToValue(vnode.context, parseInt(minValue), bind.expression)
      nObj.update(el, bind, vnode)
      return
    }

    if (maxValue < v) {
      nObj.common.setToValue(vnode.context, parseInt(maxValue), bind.expression)
      nObj.update(el, bind, vnode)
      return
    }

    el.value = v === null ? null : commaFormat(v)
  },
  inputHandler(el, bind, vnode, eventValue) {
    // eslint-disable-next-line
    if (nObj.common.getToValue(vnode.context, bind.expression.split('.')) === eventValue) {
      nObj.update(el, bind, vnode)
      return
    }

    nObj.common.setToValue(vnode.context, eventValue, bind.expression)
  },
}

Vue.directive('input-comma', nObj)
